import { useEffect } from "react";

const useCustomloadapi = (apiInput) => {
  useEffect(() => {
    //console.log("Loding");
    /*const url =
      "https://maps.googleapis.com/maps/api/js?key=" +
      process.env.REACT_APP_GOOGLE_MAP_API_KEY;*/

    const url =
      "https://maps.googleapis.com/maps/api/js?key=" +
      process.env.REACT_APP_GOOGLE_MAP_API_KEY +
      "&libraries=places&callback=initAutocomplete";

    const script = document.createElement("script");

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    

    return () => {
      //console.log("Unloding");
      document.body.removeChild(script);
    };
  }, []);

  return true;
};

export default useCustomloadapi;
